import { FeatureUsage } from '@/types/subscription'

// On Zoho and API level, the value 9999 is used to represent unlimited usage
export const UNLIMITED_USAGE = 9999

export const SIZE_UNIT_MAP: Partial<Record<FeatureUsage['unit'], string>> = {
  gb: 'GB'
}
